export const getContrastColor = (hexColor: string) => {
  // Remove the '#' character if present
  const hex = hexColor.replace("#", "");

  // Convert the hex color to RGB
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Calculate the relative luminance using the formula
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Determine the appropriate text color based on the luminance
  if (luminance > 0.5) {
    return "#000000"; // Black text for lighter backgrounds
  } else {
    return "#FFFFFF"; // White text for darker backgrounds
  }
};
